import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  dateWrapper: {
    zIndex: 1000,
  },
}));
